import React from 'react';

const steps = [
  'Se contrata por 2 meses',
  'Aplica hasta 2 alojamientos',
  'Los espacios destacados se asignan por orden de contratación',
  'Algunos planes incluyen beneficio comercial en la comisión',
  'Finalizada la campaña, todo vuelve a su estado normal',
];

const CampanaHowItWorks = () => {
  return (
    <section className="campana-how-it-works">
      <div className="campana-how-it-works__container">
        <div className="campana-how-it-works__header">
          <h2 className="campana-how-it-works__title">¿Cómo funciona?</h2>
        </div>

        <div className="campana-how-it-works__content">
          <ul className="campana-how-it-works__list">
            {steps.map((step, index) => (
              <li key={index} className="campana-how-it-works__item">
                <div className="campana-how-it-works__check">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                </div>
                <p className="campana-how-it-works__text">{step}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default CampanaHowItWorks;
